import { lazy } from '../../shared/deployment';

export const InputUrlSearchParamQuery = lazy(() => import('./InputUrlSearchParamQuery'));
export const InputUrlSearchParamDropDown = lazy(() => import('./InputUrlSearchParamDropDown'));
export const InputUrlSearchParamSwitch = lazy(() => import('./InputUrlSearchParamSwitch'));
export const InputUrlSearchParamDate = lazy(() => import('./InputUrlSearchParamDate'));
